import { LegalLayout, LegalSection, Todo } from "@/pages/legal/LegalLayout";
import { SITE, LEGAL } from "@/config/site";

const V = ({ children }) => (children === "À COMPLÉTER" ? <Todo>À compléter</Todo> : children);

export default function Confidentialite() {
  return (
    <LegalLayout title="Politique de confidentialité" crumbLabel="Politique de confidentialité" path="/politique-confidentialite" description="Politique de confidentialité et traitement des données personnelles — FRELONS50.">
      <LegalSection heading="Responsable du traitement">
        <p>Les données collectées via ce site sont traitées par <V>{LEGAL.raisonSociale}</V>. Pour toute question : {LEGAL.dpo}.</p>
      </LegalSection>

      <LegalSection heading="Données collectées">
        <p>Lorsque vous remplissez le formulaire de demande d'intervention, nous collectons : votre nom, prénom, téléphone, e-mail (facultatif), l'adresse concernée, la description de la situation et, le cas échéant, les photos que vous transmettez.</p>
      </LegalSection>

      <LegalSection heading="Finalité">
        <p>Ces données servent uniquement à traiter votre demande, à vous recontacter et à organiser une éventuelle intervention. Elles ne sont ni vendues ni cédées à des tiers à des fins commerciales.</p>
      </LegalSection>

      <LegalSection heading="Base légale">
        <p>Le traitement repose sur votre consentement, recueilli lors de l'envoi du formulaire.</p>
      </LegalSection>

      <LegalSection heading="Durée de conservation">
        <p>{LEGAL.conservationDemandes}</p>
      </LegalSection>

      <LegalSection heading="Sous-traitant technique">
        <p>Les demandes du formulaire de contact sont acheminées via le service FormSubmit, qui assure la transmission de la demande par e-mail à l'entreprise.</p>
      </LegalSection>

      <LegalSection heading="Vos droits">
        <p>Conformément au RGPD, vous disposez d'un droit d'accès, de rectification, d'effacement et d'opposition sur vos données. Pour exercer ces droits, écrivez à {SITE.email}.</p>
      </LegalSection>

      <LegalSection heading="Cookies">
        <p>Ce site n'utilise aucun cookie de mesure d'audience non essentiel avant votre consentement. Vous pouvez gérer vos préférences depuis la page « Gestion des cookies ».</p>
      </LegalSection>
    </LegalLayout>
  );
}
